import axios from 'axios';
import { apiPut, apiUpload } from '../api/client';

// Create axios instance with base configuration for API calls
const api = axios.create({
    baseURL: process.env.REACT_APP_SERVER_API,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
});

// Add request interceptor for the current-branch hint. The auth credential
// is the HttpOnly cookie, attached by withCredentials above — no token here.
api.interceptors.request.use((config) => {
    const currentBranch = localStorage.getItem('currentBranch');
    if (currentBranch) {
        try {
            const branchData = JSON.parse(currentBranch);
            if (branchData?.id) {
                config.headers['X-Current-Branch'] = branchData.id;
            }
        } catch (e) {
            // Invalid JSON in currentBranch
        }
    }
    return config;
});

export default api;

// These helpers used to issue raw fetch() calls without the X-CSRF-Token
// header, so the global csrfGuard rejected them with 403 and the file
// uploads silently failed. They now go through the shared client wrapper,
// which attaches the CSRF token, the X-Current-Branch header, and sends
// FormData bodies as multipart.
//
// The old fetch code returned the server's JSON body even on error status
// (it never threw on !res.ok) and the calling sagas rely on inspecting
// that body, so mirror those semantics here.

export const updatePatientImagingAttachement = async (fileArray, id) => {
    try {
        return await apiPut(`api/post-patient-medical-history/${id}`, fileArray);
    } catch (error) {
        // error.message is the client's user-facing wording of the server's
        // message (no raw "CSRF validation failed" and the like).
        if (error?.body) return { ...error.body, message: error.message };
        console.log(error, "errrr");
        throw error;
    }
}



export const uploadPatientFiles = async (files, currentBranch, id) => {
    try {
        return await apiUpload(`api/post-patient-medical-images/${id}`, files);
    } catch (error) {
        if (error?.body) return error.body;
        console.log(error, "errrr");
        throw error;
    }
}
